import React from 'react'
import { Button, Grid, Popup } from 'semantic-ui-react'

const { Row, Column } = Grid

const getValue = (pressedButton, currentValue, multiple, required) => {
  if (!multiple) {
    if (!required && pressedButton === currentValue) return ''
    return pressedButton
  }
  const index = currentValue.indexOf(pressedButton)
  if (index === -1) {
    currentValue.push(pressedButton)
    return currentValue
  }
  currentValue.splice(index, 1)
  return currentValue
}

const SwitchField = ({
  after,
  before,
  children,
  className,
  disabled,
  error,
  label,
  multiple,
  onChange,
  options,
  required,
  tooltip,
  validated,
  value,
}) => (
  <Row className={`field switch ${className}${required ? ' required' : ''}`}>
    <Column width={4}><span className="field-label">{label}: </span></Column>
    <Column width={8}>
      {before}

      {options.filter(option => !disabled || option.value === value).map((option) => (
        <Button
          active={option.value === value}
          compact
          disabled={disabled}
          key={`${name}_option_${option.value}`}
          onClick={() => onChange({ value: getValue(option.value, value, multiple, required) })}
          toggle
          type="button"
        >
          {option.text}
        </Button>
      ))}
      {after}

      {!!tooltip &&
        <Popup
          trigger={<i className="daicon daicon-Help tooltip" />}
          content={tooltip}
          position="right center"
        />

      }
    </Column>
    <Column width={4}>
      {!!error &&
        <Popup
          trigger={<i className="daicon daicon-Attention error" />}
          content={error}
          position="right center"
        />
      }

      {validated && !error &&
        <i className="daicon daicon-Checkmark success" />
      }

      {children}

    </Column>
  </Row>
)

SwitchField.defaultProps = {
  after: null,
  before: null,
  children: null,
  className: '',
  disabled: false,
  error: '',
  multiple: false,
  required: false,
  tooltip: '',
  validated: false,
}

SwitchField.propTypes = {
  after: React.PropTypes.any,
  before: React.PropTypes.any,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.any,
  error: React.PropTypes.string,
  label: React.PropTypes.string.isRequired,
  multiple: React.PropTypes.bool,
  name: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  options: React.PropTypes.array.isRequired,
  required: React.PropTypes.bool,
  tooltip: React.PropTypes.string,
  validated: React.PropTypes.bool,
  value: React.PropTypes.any.isRequired,
}

export default SwitchField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Switch.js